import React from "react";
import { Row, Col } from "react-bootstrap";
import "./PercentageBar.css";

function CreateBar(props) {
  const widthStyle = {
    width: props.percentage + "%",
  };
  var percent = props.percentage;
  var isWholeNumber = percent - Math.floor(percent) === 0;
  if (isWholeNumber) percent = props.percentage;
  else percent = props.percentage.toFixed(1);
  return (
    <div>
      <Row>
        <Col xs={1} className="domain-id-col">
          <p>{props.domainID}</p>
        </Col>
        <Col>
          <div className="bar-bg">
            <div className="bar-progress" style={widthStyle}>
              {percent}%
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export { CreateBar };
